// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentCardCollectible-module_container_2509_","button":"ContentCardCollectible-module_button_35sbR","icon":"ContentCardCollectible-module_icon_UeL4B"};